<template>
  <v-card class="pa-0 text-center" rounded="md" outlined>
    <v-card-title v-if="account.logo" :style="`background: ${colorBackground ? colorBackground : account.color_background}`">
      <v-row justify="center">
        <v-sheet class="overflow-hidden" width="90" color="white" rounded="circle" outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="90">
              <v-img :src="account.logo.split(/[?#]/)[0]" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
      </v-row>
    </v-card-title>
    <v-card-subtitle :style="`background: ${colorBackground ? colorBackground : account.color_background}`">
      <v-row>
        <v-col class="pb-0 text-center" cols="12">
          <span class="d-block subtitle-1 white--text font-weight-medium mt-1">Tienes {{counter}} facturas pendientes de pago por un total de {{sum | currency(instance.currency)}} {{instance.currency}}</span>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="py-0">
      <v-row>
        <v-col class="pa-0" cols="12">
          <v-textarea class="elevation-0" v-model="messageBody" @input="updateMessage($event)" :placeholder="placeholder" auto-grow solo flat hide-details />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-progress-circular v-if="loader" indeterminate color="primary" />
          <v-simple-table class="mb-1 v-sheet--outlined rounded" v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left background pa-2 subtitle-2" style="border-radius:8px 0 0 0">Factura</th>
                  <th class="text-right background pa-2 subtitle-2" style="width:100px">Total</th>
                  <th class="text-right background pa-2 subtitle-2" style="width:100px">Vencimiento</th>
                  <th class="text-right background pa-2 subtitle-2" style="border-radius:0 8px 0 0"></th>
                </tr>
              </thead>
              <tbody class="text--primary">
                <tr class="no-hover" v-for="i in invoices" :key="i.id">
                  <td class="text-left pa-2">{{i.document.name}}<br />Nº {{i.number}}</td>
                  <td class="text-right pa-2" style="width:100px">{{i.total_adjusted | currency(i.currency)}} {{i.currency}}</td>
                  <td class="text-right pa-2" style="width:100px">{{i.due_date | date}}</td>
                  <td class="text-right pa-2">
                    <v-btn :style="`background-color:${colorBackground ? colorBackground : account.color_background};`" height="32" dark small :ripple="false">Pagar</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReminderViewMixin from '@/mixins/ReminderViewMixin'

export default {
  mixins: [
    ReminderViewMixin
  ],
  data: () => ({
    counter: null,
    invoices: [],
    loader: false,
    sum: null
  }),
  created () {
    this.loader = true

    this.$store.dispatch('invoices/LIST', {
      resource: 'invoices',
      query: {
        customer: this.instance.id,
        status: 'finalized'
      },
      setState: false
    })
    .then((response) => {
      this.counter = response.data.count
      this.invoices = response.data.results

      this.sum = this.sumProperty(this.invoices, 'total_adjusted')
    })
    .finally(() => {
      this.loader = false
    })
  }
}
</script>